export default {
	meta: {
		title: 'SmsValidation',
		description: 'Validation du sms'
	},
	title: 'J’accède à mon espace',
	headertext: 'Veuillez saisir le code temporaire qui vous a été envoyé par SMS au {mobile}.',
	textlabel: 'Code temporaire envoyé par SMS',
	smsResendLabel: 'Me renvoyer un code',
	buttons: {
		valid: 'Valider',
		back: 'Retour'
	},
	reset: {
		success: 'Un nouveau code d’authentification a été envoyé'
	}
};
